import userInfoStore from "@/store/user.store";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountManager from "../AccountManage";
import useGetDisplayUserInfo from "../useGetDisplayUserInfo";
import UserAvatar from "../UserAvatar";
import ActionSheet from "@/component/ActionSheet";
import WebInfoIcon from "@/assets/common/ic_web_info.svg?react";
import FeedbackIcon from "@/assets/common/ic_feedback_mobile.svg?react";
import AboutIcon from "@/assets/common/ic_about_mobile.svg?react";
import UserInfoMobile from "../UserInfoMobile";
import MobileConfirmModal from "@/component/MobileConfirmModal";
import { setLoginSize } from "@/utils/window";
import { message } from "antd";
import { userLogout } from "@/services/api_user";
import MobileAboutModal from "../MobileAboutModal";
import SwitchCompany from "@/sections/SwitchCompany";
import { copyText } from "@common/utils";

interface IOptions {
  id: string;
  label: React.ReactNode;
}

const User = () => {
  const [showSelect, setShowSelect] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);

  const [showAccount, setShowAccount] = useState(false);

  const navigate = useNavigate();

  const userInfo = userInfoStore();

  const { displayUserInfo } = useGetDisplayUserInfo();

  const categoryList: IOptions[] = useMemo(() => {
    const webInfo = {
      id: "WEBINFO",
      label: (
        <div className="flex items-center h-11">
          <WebInfoIcon className="mr-3" />
          网页端 (i.maxhub.com)
        </div>
      ),
    };

    const about = {
      id: "ABOUT",
      label: (
        <div className="flex items-center h-11">
          <AboutIcon className="mr-3" />
          关于
        </div>
      ),
    };

    const feedback = {
      id: "FEEDBACK",
      label: (
        <div className="flex items-center h-11">
          <FeedbackIcon className="mr-3" />
          问题反馈
        </div>
      ),
    };

    const list = [webInfo, feedback, about];

    return list as IOptions[];
  }, []);

  const openAboutModal = () => {
    setShowAboutModal(true);
  };

  const handleChoose = async (value: IOptions) => {
    if (value.id === "WEBINFO") {
      const res = await copyText(`https://i.maxhub.com/`);
      if (res) message.success("复制成功，去电脑端打开网页端");
    } else if (value.id === "ABOUT") {
      openAboutModal();
      setShowSelect(false);
    } else if (value.id === "FEEDBACK") {
      navigate(`/mobileFeedback?mobile=${userInfo.mobile}&userId=${userInfo.userId}`);
      setShowSelect(false);
    }
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
    setShowSelect(false);
  };

  const logout = async () => {
    const res = await userLogout();
    if (res) {
      setLoginSize();
      navigate("/login", { replace: true });
    } else {
      message.warning("退出登录失败");
    }
  };

  const hideLogoutModal = () => {
    setShowLogoutModal(false);
  };

  const hideAboutModal = () => {
    setShowAboutModal(false);
  };

  return (
    <div
      className="flex items-center cursor-pointer relative no_drag"
      onClick={() => {
        setShowSelect(true);
      }}
    >
      {showAccount && (
        <AccountManager
          onClose={() => {
            setShowAccount(false);
          }}
        ></AccountManager>
      )}
      <ActionSheet visible={showSelect} setVisible={setShowSelect}>
        <div className="h-full fixed left-0 bottom-0 bg-#FBFBFB text-mx-secondary text-4 text-center flex">
          <div className="w-20 h-full bg-#F4F6F9 pt-13 pb-4">
            <SwitchCompany />
          </div>
          <div className="w-62.5 pt-12 relative">
            <UserInfoMobile userInfo={displayUserInfo} disableEdit={true} />
            <div className="mt-8">
              {categoryList.map((item) => {
                return (
                  <div
                    key={item.id}
                    className="mb-3 ml-2 w-58.5 pl-4.25 rd-1.5 text-size-3.5 color-mx-secondary hover:bg-#F4F6F9 flex flex-items-center cursor-pointer"
                    onClick={() => {
                      handleChoose(item);
                    }}
                  >
                    <span>{item.label}</span>
                  </div>
                );
              })}
            </div>
            <div
              className="absolute bottom-14 w-40 h-12.5 lh-12.5 text-align-center rd-2.5 bg-#F4F6F9 text-mx-error left-1/2 -translate-x-1/2 hover:bg-#ECEEF3"
              onClick={handleLogout}
            >
              退出登录
            </div>
          </div>
        </div>
      </ActionSheet>
      <div
        className="h-8 w-8 rounded-full no_drag relative"
        onClick={() => {
          setShowSelect(true);
        }}
      >
        <UserAvatar
          userInfo={displayUserInfo}
          className="w-8 h-8 text-10.5px font-600"
        />
      </div>
      <MobileConfirmModal
        visible={showLogoutModal}
        onCancel={hideLogoutModal}
        onConfirm={logout}
        title="确认退出登录吗？"
      />
      <MobileAboutModal visible={showAboutModal} onCancel={hideAboutModal} />
    </div>
  );
};

export default User;
